<template>
  <div class="container">
    <transition name="fade">
      <div class="modal-mask" @click="close()">
        <div class="modal-wrapper" >
          <div class="modal-container" v-on:click.stop>
            <div class="closeIcon" >
              <span class="icon-x"  @click="close()"></span>
            </div>
            <div class="modal-body">
              <slot name="body">
                default body
              </slot>
            </div>


          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script type="text/x-template" id="modal-template">

</script>

<script>
export default {
  name: 'v-modal',
  methods: {
    close: function () {
      this.$emit('close')
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.closeIcon{
  text-align:right;
  font-size:2em;
  color:#ccc;
  line-height:1em;
  margin-right:-20px;
  padding-top:8px;
}
.modal-container {
  width: 90vw;
  margin: 0px auto;
  box-sizing:border-box;
  padding: 0px 30px 20px 30px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}


.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.fade-enter {
  opacity: 0;
}

.fade-leave-active {
  opacity: 0;
}

.fade-enter .modal-container,
.fade-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>



// WEBPACK FOOTER //
// src/components/modal/index.vue